// @flow

import * as React from "react";
import { useDispatch } from "react-redux";
import { ReactForm, ReactFormField } from "@adrenalin/react-form";

import { applyPromo } from "../../actions/cart";
import useAsyncState from "../../hooks/useAsyncState";
import ServerErrorMessage from "../atoms/ServerErrorMessage";

type PropsType = { className?: string };

const PromoCode = (props: PropsType): React.Node => {
    const dispatch = useDispatch();
    const [state, localActions] = useAsyncState();

    const cssBaseClass = "promo-code";
    const classList = [cssBaseClass];

    if (props.className) {
        classList.push(props.className);
    }

    const handleFormSubmit = formData => {
        if (formData.code) {
            localActions.request();

            dispatch(applyPromo(formData.code))
                .then(res => {
                    localActions.success();
                })
                .catch((error: any) => {
                    console.error(error);
                    localActions.fail(error.message);
                });
        }
    };

    return (
        <div className={classList.join(" ")}>
            <ReactForm
                onSuccess={handleFormSubmit}
                className={`promo-code__form ${
                    state.error ? "is-invalid" : ""
                }`}
            >
                <ReactFormField
                    className="promo-code__field"
                    type="text"
                    label="Promo code"
                    name="code"
                    // required={true}
                />

                <button
                    type="submit"
                    className="promo-code__btn"
                    disabled={state.loading}
                >
                    Apply
                </button>
            </ReactForm>

            {state.success ? (
                <div className="promo-code__success">
                    Code applied successfully
                </div>
            ) : null}

            <ServerErrorMessage className="promo-code__error">
                {state.error}
            </ServerErrorMessage>
        </div>
    );
};

export default PromoCode;
